import Marquee from "react-fast-marquee";
import Hero from "@/components/home/Hero";
import InsideShowcase from "@/components/home/InsideShowcase";
import ValueStack from "@/components/home/ValueStack";
import Transformations from "@/components/home/Transformations";
import FounderStory from "@/components/home/FounderStory";
import Pricing from "@/components/home/Pricing";
import Faq from "@/components/home/Faq";
import FreeResources from "@/components/home/FreeResources";
import TrialCta from "@/components/home/TrialCta";

const WORDS = ["TRAIN", "TRANSFORM", "CONQUER"];

const Home = () => (
    <main data-testid="home-page">
        <Hero />
        <div className="border-y border-white/5 bg-[#070c15] py-5" data-testid="marquee-band">
            <Marquee speed={30} gradient={false} pauseOnHover>
                {Array(6).fill(WORDS).flat().map((w, i) => (
                    <span key={i} className="mx-10 flex items-center gap-10">
                        <span className="text-sm font-extrabold uppercase tracking-[0.35em] text-[#4b5a72]">{w}</span>
                        <span className="h-1.5 w-1.5 rotate-45 bg-[#f0356f]" />
                    </span>
                ))}
            </Marquee>
        </div>
        <InsideShowcase />
        <Pricing />
        <ValueStack />
        <FounderStory />
        <Transformations />
        <Faq />
        <FreeResources />
        <TrialCta />
    </main>
);

export default Home;
